/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminthreads_Colfeatured2Inputs */

const zh_adminthreads_colfeatured2 = /** @type {(inputs: Adminthreads_Colfeatured2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选`)
};

const en_adminthreads_colfeatured2 = /** @type {(inputs: Adminthreads_Colfeatured2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured`)
};

const es_adminthreads_colfeatured2 = /** @type {(inputs: Adminthreads_Colfeatured2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destacado`)
};

/**
* | output |
* | --- |
* | "Featured" |
*
* @param {Adminthreads_Colfeatured2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminthreads_colfeatured2 = /** @type {((inputs?: Adminthreads_Colfeatured2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminthreads_Colfeatured2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminthreads_colfeatured2(inputs)
	if (locale === "en") return en_adminthreads_colfeatured2(inputs)
	return es_adminthreads_colfeatured2(inputs)
});
export { adminthreads_colfeatured2 as "adminThreads_colFeatured" }